import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import toast from "react-hot-toast";
type PaymentAction = {
    id: number;
    action: string;
    performedBy: string;
    timestamp: string; // Use Date if you want to handle it as a Date object
    details: string;
  };
  
export function useNotifications(){
    const queryClient = useQueryClient();
    
  
      const Notification  = useQuery({
        queryKey: ["notification"],
        queryFn: async () => {
          try {
            const response = await axios.get(`/api/v1/notifications`);
            return response.data.data as PaymentAction[];
          } catch (error) {
            console.error("Error fetching users:", error);
            throw error;
          }
        },
        staleTime: 300000,
      });

      const deleteNotification = useMutation({
        mutationFn: async (id: number) => {
          try {
            const response = await axios.delete(`/api/v1/notificationDelete/${id}`);
            return response.data;
          } catch (error) {
            console.error("Error deleting user:", error);
            throw error;
          }
        },
     
      
        onSuccess: () => {
          queryClient.invalidateQueries({queryKey:["notification"]}); // Refresh users data
          // toast.success("Notification has deleted successfully ");

        },
      });
      
return {queryClient,Notification,deleteNotification}      
}
